class TimeZone {
  static current = () => Intl.DateTimeFormat().resolvedOptions().timeZone
}

export default TimeZone
